module.exports = __webpack_public_path__ + "img/journal-text.d5d4777a.svg";